let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Mruw4")).then(() => parcelRequire('6kjbV'));